
    export default 
    {
    "new_feature": {
        "csv_bulk_order": "CSV-Sammelbestellung",
        "describe": "Für Benutzer, die den Shopify-Service nicht nutzen"
    }
}